/**
 * Telegram WebApp SDK 的浏览器兼容层
 * 当在普通浏览器中运行时，提供模拟的 WebApp 对象
 */

const isTelegramEnvironment = typeof window !== 'undefined' && 
    window.Telegram && 
    window.Telegram.WebApp;

let WebApp;

if (isTelegramEnvironment) {
    // 在 Telegram 环境中，使用真实的 SDK
    WebApp = require('@twa-dev/sdk').default;
} else {
    // 在普通浏览器中，提供模拟实现
    WebApp = {
        initData: '',
        initDataUnsafe: {
            user: {
                id: 0,
                first_name: 'Browser User',
                last_name: '',
                username: 'browser_user',
                language_code: 'zh-cn'
            },
            hash: ''
        },
        authDate: new Date(),
        isExpanded: true,
        version: '8.0',
        platform: 'browser',
        colorScheme: 'light',
        themeParams: {
            bg_color: '#ffffff',
            text_color: '#000000',
            hint_color: '#999999',
            link_color: '#2678b6',
            button_color: '#2678b6',
            button_text_color: '#ffffff',
            secondary_bg_color: '#f0f0f0',
        },
        headerColor: '#ffffff',
        backgroundColor: '#ffffff',
        isClosingConfirmationEnabled: false,
        isActive: true,
        viewportHeight: window.innerHeight,
        viewportStableHeight: window.innerHeight,
        
        // 方法模拟
        ready: function() {},
        expand: function() {},
        close: function() {
            if (window.confirm('确定要关闭吗？')) {
                window.close();
            }
        },
        showAlert: function(message, callback) {
            alert(message);
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        showConfirm: function(message, callback) {
            const result = window.confirm(message);
            if (callback && typeof callback === 'function') {
                callback(result);
            }
            return result;
        },
        openLink: function(url, options) {
            window.open(url, '_blank', 'noopener,noreferrer');
        },
        openTelegramLink: function(url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        },
        openInvoice: function(url, callback) {
            console.warn('openInvoice 在浏览器环境中不支持');
            if (callback) callback('cancelled');
        },
        switchInlineQuery: function(query, choose_chat_types) {
            console.warn('switchInlineQuery 在浏览器环境中不支持');
        },
        shareToStory: function(media_url, params) {
            console.warn('shareToStory 在浏览器环境中不支持');
        },
        sendText: function(text, options) {
            console.warn('sendText 在浏览器环境中不支持');
        },
        enableClosingConfirmation: function() {
            this.isClosingConfirmationEnabled = true;
        },
        disableClosingConfirmation: function() {
            this.isClosingConfirmationEnabled = false;
        },
        onEvent: function(eventType, eventHandler) {
            // 简化实现，只支持基本的事件监听
            console.log('WebApp onEvent:', eventType);
        },
        offEvent: function(eventType, eventHandler) {
            console.log('WebApp offEvent:', eventType);
        },
        MainButton: {
            text: '',
            isVisible: false,
            isActive: true,
            isProgressVisible: false,
            show: function() { this.isVisible = true; },
            hide: function() { this.isVisible = false; },
            enable: function() { this.isActive = true; },
            disable: function() { this.isActive = false; },
            showProgress: function(leaveActive) { 
                this.isProgressVisible = true; 
                if (!leaveActive) this.isActive = false;
            },
            hideProgress: function() { 
                this.isProgressVisible = false; 
            },
            onClick: function(callback) {
                this._clickHandler = callback;
            },
            offClick: function(callback) {
                this._clickHandler = null;
            },
            setParams: function(params) {
                if (params.text) this.text = params.text;
                if (params.color) this.color = params.color;
                if (params.text_color) this.text_color = params.text_color;
                if (params.is_visible !== undefined) this.isVisible = params.is_visible;
                if (params.is_active !== undefined) this.isActive = params.is_active;
            }
        },
        BackButton: {
            isVisible: false,
            show: function() { this.isVisible = true; },
            hide: function() { this.isVisible = false; },
            onClick: function(callback) {
                this._clickHandler = callback;
            },
            offClick: function(callback) {
                this._clickHandler = null;
            }
        },
        SettingsButton: {
            isVisible: false,
            show: function() { this.isVisible = true; },
            hide: function() { this.isVisible = false; },
            onClick: function(callback) {
                this._clickHandler = callback;
            },
            offClick: function(callback) {
                this._clickHandler = null;
            }
        },
        HapticFeedback: {
            impactOccurred: function(style) {
                console.log('HapticFeedback impactOccurred:', style);
            },
            notificationOccurred: function(type) {
                console.log('HapticFeedback notificationOccurred:', type);
            },
            selectionChanged: function() {
                console.log('HapticFeedback selectionChanged');
            }
        },
        CloudStorage: {
            setItem: function(key, value, callback) {
                try {
                    localStorage.setItem('cloud_' + key, value);
                    if (callback) callback(null, true);
                } catch (e) {
                    if (callback) callback(e, false);
                }
            },
            getItem: function(key, callback) {
                try {
                    const value = localStorage.getItem('cloud_' + key);
                    if (callback) callback(null, value);
                } catch (e) {
                    if (callback) callback(e, null);
                }
            },
            getItems: function(keys, callback) {
                try {
                    const values = keys.map(key => localStorage.getItem('cloud_' + key));
                    if (callback) callback(null, values);
                } catch (e) {
                    if (callback) callback(e, []);
                }
            },
            removeItem: function(key, callback) {
                try {
                    localStorage.removeItem('cloud_' + key);
                    if (callback) callback(null, true);
                } catch (e) {
                    if (callback) callback(e, false);
                }
            },
            getKeys: function(callback) {
                try {
                    const keys = Object.keys(localStorage)
                        .filter(k => k.startsWith('cloud_'))
                        .map(k => k.substring(6));
                    if (callback) callback(null, keys);
                } catch (e) {
                    if (callback) callback(e, []);
                }
            }
        }
    };
    
    // 初始化 WebApp（模拟）
    WebApp.ready();
    WebApp.expand();
}

export default WebApp;
